<template>
  <div class="livesType-list">
    <Row>
      <Col :xs="24" :sm="24">
        <Form :model="formItem" ref="formItem" :inline="true" action="javascript:void(0)">
          <FormItem>
            <Button @click="showModel()" type="success" class="f-r">添加</Button>
          </FormItem>
        </Form>
      </Col>
    </Row>
    <Table border :columns="columns1" ref="selection" :data="tablelist" :loading="dataloading"></Table>
    <!-- 添加的弹出 -->
    <Modal v-model="showModalStatus" title="添加" @on-ok="createBrand()" :loading="loading">
      <Form :model="brand" action="javascript:void(0)">
        <FormItem label="名称">
          <Input v-model="brand.title" placeholder="输入名称..."></Input>
        </FormItem>
      </Form>
    </Modal>
    <!-- 修改的弹出 -->
    <Modal v-model="showEditInfoStatus" title="修改" @on-ok="updateBrand()" :loading="loading">
      <Form :model="brand" action="javascript:void(0)">
        <FormItem label="名称">
          <Input v-model="brand.title" placeholder="输入名称..."></Input>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "livesType-list",
  data() {
    return {
      loading: true,
      dataloading: true,
      formItem: {},
      columns1: [
        {
          title: "Id",
          key: "id",
          width: 100,
          fixed: "left"
        },
        {
          title: "标题",
          key: "title",
          fixed: "left"
        },
        {
          title: "操作",
          key: "action",
          align: "left",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "info",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      this.showEditInfo(params.row.id);
                    }
                  }
                },
                "修改"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.remove(params.row.id);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ],
      tablelist: [],
      brand: {},
      showModalStatus: false,
      showEditInfoStatus: false
    };
  },
  // 计算
  computed: {},
  // 监听
  watch: {},
  created: function() {
    // 取数据
    this.getTableList();
  },
  methods: {
    getTableList: function() {
      var self = this;
      this.$api.smarttickettype.list().then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          self.tablelist = res.result.list;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    // 展开添加
    showModel() {
      this.brand.title = "";
      this.showModalStatus = !this.showModalStatus;
    },
    // 添加
    createBrand(name) {
      this.$api.smarttickettype
        .create({ title: this.brand.title })
        .then(res => {
          if (res.code == 200) {
            this.showModalStatus = !this.showModalStatus;
            this.brand.title = "";
            this.getTableList();
          }
        });
      this.loading = false;
      this.$nextTick(() => {
        this.loading = true;
      });
    },
    //展开修改
    showEditInfo: function(index) {
      this.branid = index;
      this.showEditInfoStatus = !this.showEditInfoStatus;
      // 取信息
      this.$api.smarttickettype.detail({ id: index }).then(res => {
        if (res.code == 200) {
          this.brand = res.result;
          this.$Message.success(res.msg);
        }
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true;
        });
      });
    },
    // 修改名称
    updateBrand: function(name) {
      this.$api.smarttickettype
        .edit({
          id: this.branid,
          title: this.brand.title
        })
        .then(res => {
          if (res.code == 200) {
            this.$Message.success(res.msg);
            this.showEditInfoStatus = !this.showEditInfoStatus;
            this.getTableList();
          }
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
          this.showCreateStatus = !this.showCreateStatus;
        });
    },
    remove: function(index) {
      // 弹出确认框
      this.$Modal.confirm({
        title: "警告",
        content: "<p>此操作不可恢复，三思而后行...</p>",
        onOk: () => {
          this.$api.smarttickettype.remove({ id: index }).then(res => {
            if (res.code == 200) {
              this.$Message.success(res.msg);
              this.getTableList();
            }
          });
        }
      });
    }
  }
};
</script>
